import React, { useState, useEffect } from 'react';

// https://stackoverflow.com/questions/45514676/react-check-if-element-is-visible-in-dom
export default function useOnScreen(
    ref?: React.MutableRefObject<any>
): boolean {
    const [isIntersecting, setIntersecting] = useState(false);
    try {
        const observer = new IntersectionObserver(([entry]) =>
            setIntersecting(entry.isIntersecting)
        );

        useEffect(() => {
            if (ref?.current) {
                observer.observe(ref.current);
            }

            // Remove the observer as soon as the component is unmounted
            return () => {
                observer.disconnect();
            };
        }, [ref?.current]);

        return isIntersecting;
    } catch (err) {
        // if intersection observer is not defined just return false
        console.warn(err);
    }
    return false;
}
